<div class="l-core-contents__inner">
  <div class="l-core-contents__main">
    <div class="p-error-block">
      <div class="p-error-block__inner">
        <ng-container *ngIf="fixedErrorMsgKey">
          <p class="p-error-block__message">
            <em class="p-error-block__text" [innerHTML]="(fixedErrorMsgKey | staticMsg) + (displayErrorKey || '')"></em>
          </p>
        </ng-container>
        <ng-container *ngIf="!fixedErrorMsgKey">
          <p class="p-error-block__message">
            <em
              class="p-error-block__text"
              [innerHTML]="
                (errorMsgKeyPrefix + errorInfo?.errorMsgId!
                  | paramsTranslate : errorInfo?.params || []
                  | popupIndicator
                  | metaUrl
                  | linkStyle) + (displayErrorKey || '')
              "
            ></em>
          </p>
        </ng-container>
        <div *ngIf="showBtn" class="p-error-block__btn">
          <asw-button
            type="secondary"
            size="s"
            (click$)="buttonClick(showCloseBtn)"
            [label]="(!showCloseBtn ? buttonLabelMsgKey : 'label.confirmError2') | staticMsg"
          ></asw-button>
        </div>
      </div>
    </div>
  </div>
  <div class="l-core-contents__sub"></div>
</div>
